import React from 'react';
import { createContentPropTypes } from '../../helpers/content';

const content = {
	templateSaved: 'Your template has been saved',
	templateCreatedAndSaved: 'Your template has been successfully created and saved',
	templateSavedExit:
		'Your template has been successfully created and saved. You can make a payment using this template and update it at any time',
	templateUpdated: 'Your template has been successfully updated',
	missingBen:
		'Since the last time this template was used, either an account or payee has been removed or modified. Please select a new one or delete the row for this payment. ',
	missingBenTemplate:
		'Since the last time this payment template was saved, either an account or payee has been removed or modified. Please select a new one or delete the row for this payment.',
	editTemplateText: 'To make a permanent change you can',
	editTemplateButtonText: 'edit the template',
	serviceErrorDuringPaymentUpload: <strong>Sorry we couldn’t check the file</strong>,
	serviceErrorDuringPaymentUploadDescription:
		'There’s been a technical problem and we haven’t been able to check or save your payments. Please try importing the file again.',
	backendBenImportError: 'Sorry. ',
	backendBenImportWithAllError: 'We imported ',
	backendBenImportWithAllDuplicates: 'We imported ',
	backendBenImportWithAllErrorsAndDuplicates: 'We imported ',
	backendBenImportPartialSuccessWithError: 'We imported ',
	backendBenCheckingPartialSuccessWithError: 'We could successfully check ',
	backendBenImportPartialSuccessWithoutError: 'We imported ',
	frontEndError: <strong>We can’t import this file</strong>,
	frontEndEmptyFileError: <strong>There’s nothing to import</strong>,
	frontEndErrorBacsPayment: <strong>We can’t import this file</strong>,
	frontEndErrorFPSPayment: <strong>We can’t import this file</strong>,
	permissionError: <strong>You need permission</strong>,
	sourceAccountLimitErrorDescription:
		'You have tried to upload a file with too many source accounts. There should be a maximum of 10 source accounts per file. Please try importing the file again.',
	permissionErrorDescription:
		'You don’t have the necessary permission to import payments on this account. Please contact your corporate administrator about your permissions.',
	deletePayee: '',
	nameNotCheckedBody:
		'We’ve not checked this account with the name-matching service before. For added security, please review their details before continuing.',
	nameNotCheckedTitle: 'Name Not Checked',
	checkNowBtn: 'Check Now',
	cancelBtn: 'Cancel',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
